<mat-card class="mt-3 animated fadeIn fadeOut">
  <mat-card-title>
    Paciente
  </mat-card-title>
  <mat-card-content>
    <form [formGroup]="patient" (ngSubmit)="searchPatient(patientsModal, patientCreateModal)">
      <div class="row" >
        <mat-form-field class="col-md-4">
          <mat-label>DNI</mat-label>
          <input matInput placeholder=""
            type="text"
            name="fiscalCode" autofocus
            formControlName="fiscalCode" name="dni">
        </mat-form-field>
        <mat-form-field class="col-md-4">
          <mat-label>Nombre</mat-label>
          <input matInput type="text"
            name="name"
            id="name"
            formControlName="name">
        </mat-form-field>
        <mat-form-field class="col-md-3">
          <mat-label>Apellido</mat-label>
          <input matInput type="text"
            name="surname"
            id="surname"
            formControlName="surname" >
        </mat-form-field>

        <div class="col-lg-1 text-center">
          <button mat-raised-button color="primary" type="submit" > <mat-icon>search</mat-icon> </button>
          <button mat-raised-button class="mt-1" color="secondary" > <mat-icon>delete</mat-icon> </button>
        </div>
      </div>
      <!--div class="row">
        <div class="ml-auto mr-auto">
          <button mat-raised-button color="secondary" > Limpiar </button>
          <button mat-raised-button color="primary" type="submit" > Buscar </button>
        </div>
      </div-->
    </form>
  </mat-card-content>
</mat-card>
<!--
<div class="card">
  <div class="card-header">
    Paciente
  </div>
  <div class="card-body">
    <form [formGroup]="patient" (ngSubmit)="searchPatient(patientsModal, patientCreateModal)">
      <div class="row">
        <div class="col-lg-4">
          <div class="form-group">
            <label>DNI</label>
            <input type="text"
                   class="form-control"
                   name="fiscalCode" autofocus
                   formControlName="fiscalCode">
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="name">Nombre</label>
            <input type="text"
                   class="form-control"
                   name="name"
                   id="name"
                   formControlName="name">
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="surname">Apellido</label>
            <input type="text"
                   class="form-control"
                   name="surname"
                   id="surname"
                   formControlName="surname">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4">
          <div class="col-md-6 ml-auto mr-auto">
            <div class="form-group">
              <button type="button" class="btn btn-block  btn-primary btn-round" style="background: #af9900 !important; border-color: #af9900!important;">
                          <span class="btn-label">
                              <i class="fas fa-eraser"></i>
                          </span>
                <strong>LIMPIAR</strong>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-4 ml-auto">
          <div class="col-md-6 ml-auto mr-auto">
            <div class="form-group">
              <button type="submit" class="btn btn-block btn-primary btn-round">
                          <span class="btn-label">
                              <i class="fa fa-search"></i>
                          </span>
                <strong>BUSCAR</strong>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>-->
<ng-template #patientsModal let-c="close" let-d="dismiss" class="animated fadeIn fast">
  <div class="modal-header">
    <!-- <h4 class="modal-title" id="modal-basic-title">Hi there!</h4> -->
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <table class="table table-striped">
      <thead>
      <tr>
        <th scope="col">Nombre</th>
        <th scope="col">Apellido</th>
        <th scope="col">DNI</th>
        <th scope="col">Sexo</th>
        <th scope="col">Fecha de nacimiento</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let patient of patients" (click)="selectPatient(patient)">
        <td>{{ patient.name}}</td>
        <td>{{ patient.surname }}</td>
        <td>{{ patient.fiscalCode }}</td>
        <td>{{ patient.sex }}</td>
        <td>{{ patient.birthdate }}</td>
      </tr>
      </tbody>
    </table>
    <div class="row">
      <button class="btn btn-block btn-outline-secondary" (click)="d('Cross click')">Volver</button>
    </div>
  </div>
</ng-template>
<ng-template #patientCreateModal let-c="close" let-d="dismiss" class="animated fadeIn fast">
  <div class="modal-header">
    <!-- <h4 class="modal-title" id="modal-basic-title">Hi there!</h4> -->
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form [formGroup]="newPatient" (ngSubmit)="createPatient()">
    <div class="modal-body">
      <div class="row">
        <div class="col-lg-4">
          <div class="form-group">
            <label>Nombre</label>
            <input type="text"
                   class="form-control"
                   autofocus
                   formControlName="name">
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label>Apellido</label>
            <input type="text"
                   class="form-control"
                   formControlName="surname">
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label>Fecha de Nacimiento</label>
            <input type="text"
                   class="form-control"
                   formControlName="birthdate">
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label>DNI</label>
            <input type="text"
                   class="form-control"
                   formControlName="fiscalCode">
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label>Número de Obra Social</label>
            <input type="text"
                   class="form-control"
                   formControlName="healthCode">
          </div>
        </div>
        <div class="col-lg-2">
          <div class="form-group">
            <label>Sexo</label>
            <input type="text"
                   class="form-control"
                   formControlName="sex">
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label>Dirección</label>
            <input type="text"
                   class="form-control"
                   formControlName="address">
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label>Teléfono</label>
            <input type="text"
                   class="form-control"
                   formControlName="phone">
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label>Email</label>
            <input type="email"
                   class="form-control"
                   formControlName="email">
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-block btn-outline-secondary" (click)="d('Cross click')">Volver</button>
      <button class="btn btn-block btn-outline-secondary" type="submit">Crear paciente</button>
    </div>
  </form>
</ng-template>
